"use client";

import { c as _c } from "react/compiler-runtime";
import { env } from "~/setup/env";
import type { JobadComponentProps } from "~/types/job";
export default function CompanyControlsolutions(t0) {
  const $ = _c(7);
  const {
    job
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      backgroundImage: `url(${env.NEXT_PUBLIC_ASSET_URL}images/jobad/company-bg.webp)`,
      backgroundSize: "cover",
      backgroundPosition: "right"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== job.data.company) {
    t2 = <h2 className="mb-10 font-bold text-4xl md:text-5xl print:text-lg">{job.data.company}</h2>;
    $[1] = job.data.company;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p>E.ON Control Solutions are looking for individuals who want to be part of an industry leading company with aspirations of future growth. We recognise that our staff will be the main driver in allowing us to reach our goals. We recognise the importance of a highly motivated, dynamic and skilled workforce who can provide excellence in all aspects of the BEMS Industry. Here are our current vacancies.</p>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="gap-20 text-lg md:columns-2 [&>p]:mb-4">{t3}<p>Whilst the listed vacancies below may not be the perfect fit for you, we are always looking to recruit high quality professionals from the BEMS industry. If you are a Sales Professional, Project Manager, Commissioning, Design or Service Engineer who wants to join a business at the forefront of the industry, why not get in touch. Send us your CV, along with a covering letter giving details of your experience and aspirations, to{" "}<a className="underline" data-source="job" href="mailto:careers@eon-controls.com">careers@eon-controls.com</a>{" "}and we’ll be in touch.</p></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2) {
    t5 = <section className="bg-[#0f738A] px-6 py-10 text-white md:px-10 md:py-20 print:hidden" id="company" style={t1}><div className="mx-auto flex max-w-screen-xl flex-wrap"><div>{t2}{t4}</div></div></section>;
    $[5] = t2;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}